import { FC } from "react";
import { SectionTitle } from "./SectionTitle"
import { CoachInfo } from "../../types/fixtures/match";

interface CoachesProps {
    homeCoach: CoachInfo;
    awayCoach: CoachInfo;
}

export const Coaches: FC<CoachesProps> = ({
    homeCoach,
    awayCoach
}) => {
    if (!homeCoach && !awayCoach) {
        return null;
    }


    let homeNameClasses = '';
    let guestNameClasses = '';

    if (homeCoach?.name?.length > 17) {
        homeNameClasses += ' text-lg sm:text-3xl';
    }

    if (awayCoach?.name?.length > 17) {
        guestNameClasses += ' text-lg sm:text-3xl';
    }


    return (
        <div>
            <SectionTitle>
                Тренеры
            </SectionTitle>
            <div className="flex flex-row justify-center p-2 gap-4 sm:gap-12 text-xl sm:text-2xl">
                <div className="flex flex-row justify-end items-center gap-2 text-right w-1/2">
                    {homeCoach?.photoUrl && <img src={homeCoach.photoUrl} alt={homeCoach.name} className="h-16" />}
                    <div>
                        <div className={homeNameClasses}>
                            {homeCoach?.name}
                        </div>
                        <div className="italic text-base sm:text-lg">
                            {homeCoach?.position}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-start items-center gap-2 w-1/2">
                    {awayCoach?.photoUrl && <img src={awayCoach.photoUrl} alt={awayCoach.name} className="h-16" />}
                    <div>
                        <div className={guestNameClasses}>
                            {awayCoach?.name}
                        </div>
                        <div className="italic text-base sm:text-lg">
                            {awayCoach?.position}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
